import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE } from "@/data/site";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo(title, description, { noindex = false } = {}) {
  const { pathname } = useLocation();
  useEffect(() => {
    const full = title ? `${title} | ${SITE.name}` : `${SITE.name} — Venture Studio & Product Engineering`;
    document.title = full;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    setMeta("property", "og:title", full);
    setMeta("property", "og:url", `${SITE.domain}${pathname}`);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (link) link.setAttribute("href", `${SITE.domain}${pathname === "/" ? "/" : pathname}`);
  }, [title, description, pathname, noindex]);
}
